export enum ClientBalanceTransactionDirection {
    Input = 1,
    Output = 2
}
